var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",style:({
  'background': _vm.data.infoItme.bjColor,
  'padding': ((_vm.data.infoItme.sBj) + " " + (_vm.data.infoItme.yeBj) + " " + (_vm.data.infoItme.xBj))
})},[_c('div',{staticClass:"title-content",style:({
    'color': _vm.data.conStyle.titleColor,
    'font-size': ((_vm.data.conStyle.titleSize) + "px"),
    'font-weight': _vm.data.conStyle.titleBold === '是' ? 'bold' : 'normal',
    'text-align': _vm.data.conStyle.titleAlign === '居左' ? 'left' : 'center'
  })},[_vm._v(_vm._s(_vm.data.title)+"\n    "),(_vm.data.conStyle.moreType !== '无')?_c('span',{staticClass:"more",style:({
      'color': _vm.data.conStyle.moreColor
    })},[(_vm.data.conStyle.moreType !== '图标')?_c('span',[_vm._v(_vm._s(_vm.data.conStyle.moreText))]):_vm._e(),_vm._v(" "),(_vm.data.conStyle.moreType !== '文字')?_c('i',{staticClass:"el-icon-arrow-right"}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c1df8ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title/TitlePreview.vue
// module id = null
// module chunks = 